// factory to convert an akam-popover (or akam-popover-template) to uib-popover (or
// uib-popover-template). Also adds support for keeping the popover open while hovered.

import angular from 'angular';

// custom event triggers
export const SHOW_EVENT = 'hovertooltip';
export const HIDE_EVENT = 'leavetooltip';

// global delay before showing popover, ms
export const POPUP_DELAY = 300;

// how much time we give the user to mouse away and mouse back before closing
const REF_CHECK_HOVER_DELAY = 300;

// data attribute we use to keep track of hover events on the element and the popup itself
const REF_COUNT_KEY = 'akamPopoverHoverCount';

function popover($compile, $timeout, $document) {
  return popoverName => ({
    terminal: true,
    priority: 100,
    link(scope, element) {

      // utility methods
      const closeIfNoRefCount = () => $timeout(() => {
        if (element.data(REF_COUNT_KEY) <= 0) {
          element.triggerHandler(HIDE_EVENT);
        }
      }, REF_CHECK_HOVER_DELAY);

      const increaseRefCount = () => {
        const count = element.data(REF_COUNT_KEY);
        element.data(REF_COUNT_KEY, count + 1);
      };

      const decreaseRefCount = () => {
        const count = element.data(REF_COUNT_KEY);
        element.data(REF_COUNT_KEY, count - 1);
        closeIfNoRefCount();
      };

      const closeAnyPopoverIfTriggerByClick = () => {
        const openPopoverElems = $document[0].querySelectorAll('.popover.in');
        if (openPopoverElems.length) {
          [...openPopoverElems].forEach(elem => {
            if (elem.parentNode) {
              elem.parentNode.removeChild(elem);
            }
          });
        }
      };

      const isLargePadding = element.attr('padding-size') === 'large';
      const ngIfValue = element.attr('ng-if');
      let popoverValue = element.attr(`akam-${popoverName}`);
      let suffix = '';
      let trigger = element.attr('popover-trigger');
      const delay = element.attr('popover-popup-delay') || POPUP_DELAY;

      // map popover to popover-html so we can get trusted content
      if (popoverName === 'popover') {
        popoverValue = `'${popoverValue}'`;
        suffix = '-html';
      }

      // remap click to outsideClick because our "click" closes popups when clicking away too
      if (trigger === 'click') {
        trigger = 'outsideClick';
      }

      // remap mouseenter to our custom triggers, implemented below
      if (trigger === 'mouseenter') {
        trigger = SHOW_EVENT;
      }

      // rename some akam-stuff to uib-stuff and compile
      element
        .data(REF_COUNT_KEY, 0)
        .attr(`uib-${popoverName}${suffix}`, popoverValue)
        .attr('popover-trigger', `'${trigger}'`)
        .attr('popover-class', `${isLargePadding ? 'large-padding' : ''}`)
        //Remove ng-if has already been compiled. Compiling it here again is redundant and prevents
        //popover  from keeping custom event listeners
        .removeAttr('ng-if')
        .removeAttr(`akam-${popoverName}`);

      $compile(element)(scope);

      // keep track of mouse events on this event, as well as the popup element. If the
      // ref count gets to 0, we close the popup
      element
        .on('mouseenter', () => {
          closeAnyPopoverIfTriggerByClick();
          increaseRefCount();
          element.triggerHandler(SHOW_EVENT);

          // wait for the popup to be visible -- account for the tooltip appear delay
          $timeout(() => {

            // popup might be the next element or appended to body so we try to figure that out
            const popup = element.next().hasClass('popover') ?
              element.next() :
              angular.element($document[0].body.lastElementChild);

            popup
              .on('mouseenter', () => increaseRefCount())
              .on('mouseleave', () => decreaseRefCount());
          }, delay);
        })
        .on('mouseleave', () => decreaseRefCount());
      // Re-add ng-if value to maintain markup watches were already set up when ng-if was compiled.
      if (ngIfValue) {
        element.attr('ng-if', ngIfValue);
      }
    }
  });
}

popover.$inject = ['$compile', '$timeout', '$document'];
export default popover;
